<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-21 09:19:36
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-25 17:21:05
 * @FilePath: \miniproweb\src\views\PushCustom\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="pushBodyBox">
    <div class="topbox">
      <div class="title">关注地区</div>
      <div class="PalBox">
        <div
          class="PalBoxItem"
          :data-index="item.AreaCode"
          v-for="item in dataList"
          @click="palceClick"
        >{{item.AreaName}}</div>
      </div>
    </div>
    <div class="midBox">
      <div class="title">关注类型</div>
      <div>
        <div class="typeChooseBoxItemBox">
          <van-cell-group>
            <van-cell label="暴雨:24小时降水≥50mm">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <van-icon name="underway" color="#1F8CF7" />
                <span style=" font-weight: 700;">降水</span>
                <span class="custom-title">
                  大于
                  <el-input v-model="rainvalue" size="mini" placeholder="请输入内容" style="width:80px"></el-input>mm/
                  <el-select v-model="rainTime" size="mini" style="width:80px;">
                    <el-option :label="item" :value="item" v-for="item in 24"></el-option>
                  </el-select>H
                </span>
                <!-- <van-tag type="danger">标签</van-tag> -->
              </template>
              <template #right-icon>
                <div>
                  <van-switch v-model="rainchecked" size="20px" />
                </div>
              </template>
            </van-cell>
            <van-cell label="强风:风速≥10.8米每秒">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <van-icon name="underway" color="#1F8CF7" />
                <span style=" font-weight: 700;">大风</span>
                <span class="custom-title">
                  大于
                  <el-input v-model="wind" size="mini" placeholder="请输入内容" style="width:80px"></el-input>
                  <!-- <el-select v-model="wind" size="mini" style="width:80px">
                    <el-option label="1" value="1"></el-option>
                  </el-select>-->
                  m/s
                </span>
                <!-- <van-tag type="danger">标签</van-tag> -->
              </template>
              <template #right-icon>
                <div>
                  <van-switch v-model="windchecked" size="20px" />
                </div>
              </template>
            </van-cell>
            <van-cell label="高温:气温≥35℃">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <van-icon name="underway" color="#1F8CF7" />
                <span style=" font-weight: 700;">高温</span>
                <span class="custom-title">
                  大于
                  <el-input v-model="maxTem" size="mini" placeholder="请输入内容" style="width:80px"></el-input>
                  <!-- <el-select v-model="maxTem" size="mini" style="width:80px">
                    <el-option label="1" value="1"></el-option>
                  </el-select>-->
                  ℃
                </span>
                <!-- <van-tag type="danger">标签</van-tag> -->
              </template>
              <template #right-icon>
                <div>
                  <van-switch v-model="maxTemchecked" size="20px" />
                </div>
              </template>
            </van-cell>
            <van-cell label="低温:气温≤5℃">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <van-icon name="underway" color="#1F8CF7" />
                <span style=" font-weight: 700;">低温</span>
                <span class="custom-title">
                  小于
                  <el-input v-model="minTem" size="mini" placeholder="请输入内容" style="width:80px"></el-input>
                  <!-- <el-select v-model="minTem" size="mini" style="width:80px">
                    <el-option label="1" value="1"></el-option>
                  </el-select>-->
                  ℃
                </span>
                <!-- <van-tag type="danger">标签</van-tag> -->
              </template>
              <template #right-icon>
                <div>
                  <van-switch v-model="minTemchecked" size="20px" />
                </div>
              </template>
            </van-cell>
            <van-cell>
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <van-icon name="underway" color="#1F8CF7" />
                <span style=" font-weight: 700;">允许告警时间</span>
                <span class="custom-title" style="margin-left:5px">
                  <el-select v-model="startTime" size="mini" style="width:80px">
                    <el-option :label="item" :value="item" v-for="item in timeListData"></el-option>
                  </el-select>到
                  <el-select v-model="endTime" size="mini" style="width:80px;">
                    <el-option :label="item" :value="item" v-for="item in timeListData"></el-option>
                  </el-select>时
                </span>
                <!-- <van-tag type="danger">标签</van-tag> -->
              </template>
            </van-cell>
          </van-cell-group>
          <div class="submitBtnBOx">
            <van-button type="info" size="large" @click="submitInfoData">提交</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeListData: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      rainTime: "1",
      wind: "13",
      minTem: "5",
      maxTem: "15",
      startTime: "8",
      endTime: "20",
      rainvalue: "1",
      checked: true,
      rainchecked: true,
      windchecked: true,
      minTemchecked: true,
      maxTemchecked: true,
      chooseListData: [],
      dataList: [
        {
          AreaName: "白头镇",
          x: 103.59103873550006,
          y: 30.598429125500047,
          AreaCode: "510184112"
        },
        {
          AreaName: "崇阳街道",
          x: 103.67565113950005,
          y: 30.629690525500052,
          AreaCode: "510184001"
        },
        {
          AreaName: "大划街道",
          x: 103.73384920650005,
          y: 30.58432533200005,
          AreaCode: "510184116"
        },
        {
          AreaName: "道明镇",
          x: 103.61338037200005,
          y: 30.672209144500044,
          AreaCode: "510184113"
        },
        {
          AreaName: "观胜镇",
          x: 103.67574075500005,
          y: 30.74327088800007,
          AreaCode: "510184106"
        },
        {
          AreaName: "怀远镇",
          x: 103.52516343500005,
          y: 30.738292659000052,
          AreaCode: "510184107"
        },
        {
          AreaName: "江源街道",
          x: 103.77329409750004,
          y: 30.59900953150006,
          AreaCode: "510184102"
        },
        {
          AreaName: "街子镇",
          x: 103.50931547750005,
          y: 30.81937056700005,
          AreaCode: "510184109"
        },
        {
          AreaName: "廖家镇",
          x: 103.70933290250008,
          y: 30.706484797500053,
          AreaCode: "510184104"
        },
        {
          AreaName: "隆兴镇",
          x: 103.66082618600007,
          y: 30.559213896000045,
          AreaCode: "510184114"
        },
        {
          AreaName: "三江街道",
          x: 103.77946641900007,
          y: 30.547185064000047,
          AreaCode: "510184101"
        },
        {
          AreaName: "文井江镇",
          x: 103.29517213000005,
          y: 30.79002118850005,
          AreaCode: "510184110"
        },
        {
          AreaName: "羊马街道",
          x: 103.74474356450006,
          y: 30.65515467000003,
          AreaCode: "510184103"
        },
        {
          AreaName: "元通镇",
          x: 103.59404854500005,
          y: 30.728832486000044,
          AreaCode: "510184105"
        },
        {
          AreaName: "崇庆街道",
          x: 103.59404854500005,
          y: 30.728832486000044,
          AreaCode: "510184006"
        }
      ],
      chooseArea: "",
      myopenId: null
    };
  },
  created() {
    let myCode = this.getQueryString("code");
    // console.log(this.getQueryString("code"));
    if (myCode == null) {
      alert("授权失败");
    } else {
      // alert(myCode);
      this.getOpenId(myCode);
    }
  },
  methods: {
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },

    getOpenId(id) {
      this.$axios({
        url: `http://120.79.183.250:3093/InterfaceServices/WechatService/queryWechatOauth2Token?code=${id}` // 接口地址
      })
        .then(response => {
          // alert(id);
          // alert(response.data.data);
          console.log(JSON.parse(response.data.data));
          this.myopenId = JSON.parse(response.data.data).openid;
          console.log(this.myopenId);
          // alert(this.myopenId);
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    submitInfoData() {
      if (this.chooseArea == "") {
        alert("请选择地区");
        return;
      }
      let contents = `{"prec":{"switch":${this.rainchecked},"value": ${this.rainvalue}, "hour": ${this.rainTime}}, "temMax":{"switch":${this.maxTemchecked},"value": ${this.maxTem}}, "temMin":{"switch":${this.minTemchecked},"value": ${this.minTem}}, "win":{"switch":${this.windchecked},"value": ${this.wind}}}`;
      console.log();
      this.$axios({
        method: "post",
        url:
          "http://120.79.183.250:3093/InterfaceServices/WechatCustomWeatherService/updateWechatCustomWeather", // 接口地址
        data: {
          alarmTime: `${this.startTime},${this.endTime}`,
          areaCode: this.chooseArea,
          contents: contents,
          id: "",
          peAge: "",
          peCareer: "",
          peHobby: "",
          peSex: "",
          peTraffic: "",
          peWork: "",
          peWorkTime: "",
          remarks: "",
          updateDate: "",
          wxOpenId: this.myopenId
          // wxOpenId: 11
        }
      })
        .then(response => {
          console.log(response);

          // console.log();
          // alert(JSON.stringify(response));
          if (response.data.code == 200) {
            alert("保存成功");
          } else {
            alert(response.data.message);
          }
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    palceClick(e) {
      // console.log(e.target.dataset.index);
      // console.log(this.chooseListData.includes(e.target.dataset.index));
      console.log(this.chooseListData);
      if (
        !this.chooseListData.includes(e.target.dataset.index) ||
        this.chooseListData.length == 0
      ) {
        e.target.classList.add("myactive");
        this.chooseListData.push(e.target.dataset.index);
      } else if (this.chooseListData.includes(e.target.dataset.index)) {
        console.log(this.chooseListData.indexOf(e.target.dataset.index));
        this.chooseListData.splice(
          this.chooseListData.indexOf(e.target.dataset.index),
          1
        );
        e.target.classList.remove("myactive");
      }
      // this.chooseArea = e.target.dataset.index;
      // const myBtnEl = document.querySelectorAll(".PalBoxItem");
      // myBtnEl.forEach(item => {
      //   item.classList.remove("myactive");
      // });
      console.log(this.chooseListData);
      this.chooseArea = this.chooseListData.toString(",");
    }
  }
};
</script>

<style>
.submitBtnBOx {
  width: 80%;
  margin: 10px auto;
}
.pushBodyBox {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.PalBox {
  height: 200px;
  width: 100%;
  /* background-color: aquamarine; */
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 10px;
}
.topbox {
  padding: 10px 0px;
  background-color: #27a2fa;
}
.midBox {
  padding: 0 0 10px 0px;
  background-color: #e6f3fe;
}
.PalBoxItem {
  width: 90px;
  height: 30px;
  background-color: #ebf4fe;
  border-radius: 15px;
  color: #27a2fa;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
}
.title {
  height: 30px;
  background-color: white;
  line-height: 30px;
  padding: 0 5px;
  font-size: 12px;
}
.myactive {
  color: white;
  background-color: #27a2fa;
}
</style>